// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgPhoto: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path
          fillRule="evenodd"
          d="M1.25 5.25a4 4 0 0 1 4-4h13.5a4 4 0 0 1 4 4v13.5a4 4 0 0 1-4 4H5.25a4 4 0 0 1-4-4zm19.5 8.448-2.216-2.218c-.347-.347-.96-.347-1.303 0l-2.865 2.867-6.148-6.151a.946.946 0 0 0-1.306 0L3.25 11.859v6.891a2 2 0 0 0 2 2h13.5a2 2 0 0 0 2-2zM14.3 10.02a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgPhoto);
export default Memo;
